import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Batch 9 Direct Sign Up On Sign In
 */
export const FE_BATCH_9_DIRECT_SIGN_UP_ON_SIGN_IN_041625 = experiment({
  name: "FE_BATCH_9_DIRECT_SIGN_UP_ON_SIGN_IN_041625",
  identifier: "SessionToken",
  client: ["RETAILER", "VISITOR_WEB"],
  notifyAfter: "2025-06-10",
  defaultValue: false,
  productArea: "LOGGED_OUT_RETAILERS",
});
